module.exports = __webpack_public_path__ + "static/media/Finansii-Web-mk.33398b94.jpg";